import styled, { css } from 'styled-components';

export const StyledCheckbox = styled.div`
	position: absolute;
	left: 0;
	top: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 2.4rem;
	height: 2.4rem;
	transform: translateY(-50%) scale(0.8);
	border: 1px solid ${({ theme }) => theme.colors.gray};
	background-color: ${({ theme }) => theme.colors.grayLighter2};
	transition: background-color 150ms, transform 150ms cubic-bezier(0.92, -0.01, 0, 1.46);

	:after {
		margin-top: 2px;
		opacity: 0;
		transform: scale(0.9);
		color: ${({ theme }) => theme.colors.textColor};
		transition: opacity 150ms, transform 150ms, color 150ms;
	}

	&:focus {
		transform: translateY(-50%) scale(1);
		border: 1px solid ${({ theme }) => theme.colors.grayLighter};
	}

	${({ checked }) =>
		checked &&
		css`
			transform: translateY(-50%) scale(1);
			
			&:after {
				opacity: 1;
				content: '✓';
				color: ${({ theme }) => theme.colors.secondary};
				transform: scale(1);
			}

			&:focus {
				transform: translateY(-50%) scale(1.2);
				border: 1px solid ${({ theme }) => theme.colors.gray};
			}
		`};
`;
